import WhyChooseEmajinGolf001Image from './why-choose-emajin-golf-001.webp'
import WhyChooseEmajinGolf002Image from './why-choose-emajin-golf-002.webp'
import WhyChooseEmajinGolfIcons001Image from './why-choose-emajin-golf-icons-001.webp'
import WhyChooseEmajinGolfIcons002Image from './why-choose-emajin-golf-icons-002.webp'

export {
  WhyChooseEmajinGolf001Image,
  WhyChooseEmajinGolf002Image,
  WhyChooseEmajinGolfIcons001Image,
  WhyChooseEmajinGolfIcons002Image,
}
